import ReportTable from '@/components/reports/table/ReportTable.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue';
import { mapState } from 'vuex';

export default {
  name: 'RegenerationReport',
  data () {
    return {
      reportData: null,
      loading: false,
      downloading: false,
      currentReq: null,
      filterValues: {
        reportSubCode: 'I',
        fromDatePeriod: null,
        toDatePeriod: null,
        useGenerated: [1],
        reportDataCols: ['VALUE'],
        attachReportCodes: [],
        precision: 0,
        multiply: 1000
      },
      tableHeaders: []
    }
  },
  components: {
    ReportTable,
    TableFilter
  },
  computed: {
    ...mapState(['config']),
    filters () {
      const filters = {};
      filters.reportSubCode = { type: 'select', label: this.$t('report.title'), options: Object.values(this.reportNameOptions), class: 'col-md-2' };
      filters.attachReportCodes = { type: 'checkbox', label: this.$t('report.attachReportCodes'), options: Object.values(this.reportNameOptions), class: 'col-md-6' };
      filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' };
      filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' };
      filters.precision = { type: 'number', label: this.$t('report.precision'), class: 'col-md-2' };
      filters.multiply = { type: 'select', label: this.$t('measure_types.multiply.title'), options: this.multiplyOptions, class: 'col-md-2' };
      filters.reportDataCols = { type: 'checkbox', label: this.$t('report.datacol.title'), options: this.reportDataColOptions, class: 'col-md-3' };
      filters.useGenerated = { type: 'checkbox', label: this.$t('report.useGeneratedReports'), options: [{ code: 1, text: this.$t('general.yes') }], class: 'col-md-2' };
      return filters;
    },
    reportDataColOptions () {
      return [
        { code: 'VALUE', text: this.$t('report.datacol.value') },
        { code: 'CURRENCY', text: this.$t('report.datacol.currency') },
        { code: 'RATE', text: this.$t('report.datacol.rate') }
      ];
    },
    multiplyOptions () {
      return [
        { code: 1, text: this.$t('measure_types.multiply.1') },
        { code: 1000, text: this.$t('measure_types.multiply.1000') }
      ];
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions();
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      const filterValues = this.BasicHelper.cloneObject(this.filterValues);
      this.BasicHelper.updateFilterValues(this.$route.name, filterValues);
      const self = this;
      this.loading = true;
      this.currentReq = this.ApiRequest.request('report/regeneration', this.ApiRequest.REQUEST_POST, filterValues, function (response) {
        if (response.data) {
          self.ReportHelper.setParams(self.$options.filters, self);
          response.data.forEach((report, reportIdx) => {
            report.forEach((row, rowIdx) => {
              if (row.catTitle) {
                if (typeof row.catTitle === 'string' || row.catTitle instanceof String) {
                  response.data[reportIdx][rowIdx].catTitle = self.$t(row.catTitle);
                } else {
                  response.data[reportIdx][rowIdx].catTitle = self.BasicHelper.getTranslation(row.catTitle);
                }
              }
            });
          });
          self.reportData = self.ReportHelper.createReportData(response.data, true, null, filterValues.precision, false, filterValues.reportDataCols);
        }
        self.loading = false;
      });
    },
    downloadReports () {
      const tableData = {};
      const refs = this.$refs.reportTable;
      if (refs) {
        if (refs.innerHTML) {
          tableData[0] = refs.innerHTML;
        } else {
          refs.forEach((el, key) => {
            tableData[key] = el.$el.innerHTML;
          });
        }
      }
      this.BasicHelper.tablesToExcelFile(tableData, 'ZP_Regen_' + this.filterValues.reportSubCode + (new Date()).toISOString());
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
  }
}
